import React from 'react'
import AppBar from '@mui/material/AppBar';
import MToolbar from '@mui/material/Toolbar';
import {makeStyles} from '@mui/styles';
import {Typography} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';
import Link from '@mui/material/Link';
import {useSelector} from "react-redux";


const useStyles = makeStyles(theme => ({
    appBar: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        top: 'auto',
        bottom: 0
    },
    toolbar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around'
    },
    copyright: {
        backgroundColor: 'inherit'
    },
    footer: {
        marginTop: 'auto',
        height:'100%'
    },
    appBarSpacer: theme?.mixins.toolbar,
    addMargin:{

    }
}));

export default function Footer() {
    const classes = useStyles();
    const screen = useSelector(state=> state.global.mobileScreen);


    return (
            <AppBar color="default" className={classes.appBar} style={{backgroundColor: '#f5f5f5'}}>
                {screen &&
                    <MToolbar className={classes.toolbar}>
                        <Typography><Link component={RouterLink} to="/Contact">Contact Us</Link></Typography>
                        <Typography><Link component={RouterLink} to="/Terms">Terms & Conditions</Link></Typography>
                        <Typography><Link component={RouterLink} to="/Privacy">Privacy Policy</Link></Typography>
                    </MToolbar>
                }

                <Typography variant="body2" className={classes.copyright} align="center">As an Amazon Associate I earn from
                    purchases.</Typography>
                <Typography variant="body2" className={classes.copyright} align="center">
                    {'Copyright © '}
                    <Link color="inherit"
                          href="https://find-and-update.company-information.service.gov.uk/company/13087131">
                        The Pantry Life
                    </Link>{' '}
                    {new Date().getFullYear()}
                    {'.'}
                </Typography>
            </AppBar>

)
}

